<script lang="ts">
    import { translation } from "../../../stores.js";
    import { roomStore } from "../../../stores/roomStore.js";

    import { hangupPeerConnection } from "../../../stores/peerConnectionStore.js";
    import Waiting from "../../Waiting/Waiting.svelte";
    import { onDestroy } from "svelte";

    import CameraCall from "../Mode/Camera/CameraCall.svelte";
    import ScreensharingCall from "../Mode/Screensharing/ScreensharingCall.svelte";
    import CallHeader from "../CallHeader.svelte";
    import CallRemoteVideo from "../CallRemoteVideo.svelte";

    $: room = $roomStore;

    onDestroy(() => {
        console.log("[CallVideo][onDestroy]");
        hangupPeerConnection();
    });
</script>

{#if room}
    <CallHeader
        title={translation.alert.inCall}
        roomId={room.id}
        roomType={room.type}
        audioEnabled={room.audioEnabled}
    />
    <!-- <CallGeoloc /> -->
    <CallRemoteVideo />

    {#if room?.type === "video"}
        <CameraCall />
    {:else if room?.type === "screensharing"}
        <ScreensharingCall />
    {/if}
{:else}
    <Waiting text={translation.alert.waitingAuthorization} />
{/if}
